module.exports = __webpack_public_path__ + "static/media/user_image.6196036f.png";